import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Footer from "./Footer";
import Menu from "./Navbar";

const Blog = () => {
  const history = useHistory();

  useEffect(() => {
    let timer = setTimeout(function () {
      if (document.querySelector(".loader-wrapper")) {
        document.querySelector(".loader-wrapper").style = "display: none";
      }
    }, 2000);
      window.scrollTo(0, 0);
    return () => clearTimeout(timer);
  }, []);

  const [bgImg, setBgImg] = useState({
    backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/team-img-bg.png)`
  });

  const color = localStorage.getItem("color");

  useEffect(() => {
    if (color === "color-1") {
      setBgImg({
        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/team-img-bg.png)`
      });
    } else if (color === "color-2") {
      setBgImg({
        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/color/color-2/team-img-bg.png)`
      });
    } else {
      setBgImg({
        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/color/color-3/team-img-bg.png)`
      });
    }
  }, [color]);

  // BLOG DATA (You will add more blogs later)
  const blogs = [
    {
      slug: "choose-property-management",
      title: "How to Choose Property Management Software (Guide 2025)",
      date: "January 2025",
      image: `${process.env.PUBLIC_URL}/assets/images/blog/Blog1.png`,
      author: "Rise & Nest Team",
      hits: 120,
      comments: 12
    },
    // {
    //   slug: "tenant-experience-boost",
    //   title: "How to Improve Your Tenant Experience",
    //   date: "January 2025",
    //   image: `${process.env.PUBLIC_URL}/assets/images/blog/Blog2.png`,
    //   author: "Rise & Nest Team",
    //   hits: 98,
    //   comments: 6
    // },
    // {
    //   slug: "automation-in-property",
    //   title: "Why Automation is the Future of Property Management",
    //   date: "February 2025",
    //   image: `${process.env.PUBLIC_URL}/assets/images/blog/blog3.jpg`,
    //   author: "Rise & Nest Team",
    //   hits: 72,
    //   comments: 4
    // }
  ];

  return (
    <>
    <Menu homePage="home-three" />
    <section id="blog" className="blog" style={{marginTop:"50px"}}>
      <div className="container">

        <h2 className="title">latest <span>blog</span></h2>

        <div className="row">
          {blogs.map((blog, i) => (
            <div className="col-md-4 col-sm-6 mb-4" key={i}>
              <div className="blog-item">

                <div className="blog-block" style={bgImg}>
                  <div className="blog-box">
                    <div className="overflow-hidden">
                      <img
                        src={blog.image}
                        alt={blog.title}
                        onClick={() => history.push(`/blog/${blog.slug}`)}
                        style={{
                          width: "100%",
                          height: "260px",
                          objectFit: "cover",
                          cursor: "pointer"
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="blog-text">
                  <h6>{blog.date}</h6>

                  <h3
                    style={{ cursor: "pointer" }}
                    onClick={() => history.push(`/blog/${blog.slug}`)}
                  >
                    {blog.title}
                  </h3>

                  <h5>
                    Posted by {blog.author}
                    {/* , {blog.hits} hits, {blog.comments} comments */}
                  </h5>
                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
        <Footer />

    </>

  );
};

export default Blog;
